import { render, staticRenderFns } from "./UsersUpdate.vue?vue&type=template&id=20328bdc"
import script from "./UsersUpdate.vue?vue&type=script&lang=js"
export * from "./UsersUpdate.vue?vue&type=script&lang=js"
import style0 from "./UsersUpdate.vue?vue&type=style&index=0&id=20328bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports